/**
 * Angular's `number` pipe with the app's default en-US locale (`{{ x | number: '1.2-2' }}`): null, undefined and ''
 * render as nothing, thousands separators, and the given minimum/maximum fraction digits.
 */
export function decimalPipe(value: number | string | null | undefined, minFraction = 2, maxFraction = 2): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const parsed = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(parsed)) {
    return '';
  }
  return parsed.toLocaleString('en-US', { minimumFractionDigits: minFraction, maximumFractionDigits: maxFraction });
}

/** `${period.fromDate} to ${period.toDate}`, the period ng-selects' label. */
export function periodLabel(period: { fromDate: string; toDate: string }): string {
  return `${period.fromDate} to ${period.toDate}`;
}
